import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Calculator, BookOpen, ArrowRight, LogOut, Sparkles } from 'lucide-react';

const SESSION_KEY = 'admin_authenticated';

const sections = [
  {
    id: 'simulateurs',
    title: 'Simulateurs',
    description: 'Accédez aux simulateurs Amazon (AMZ CW.Dz, AMZ CW.Fr, Amazon Ads)',
    icon: Calculator,
    path: '/admin/simulateurs'
  },
  {
    id: 'playbooks',
    title: 'Playbooks',
    description: 'Consultez les playbooks et guides stratégiques',
    icon: BookOpen,
    path: '/admin/playbooks'
  },
  {
    id: 'wavepix',
    title: 'WavePix',
    description: 'Générez des visuels IA optimisés pour vos fiches produits Amazon',
    icon: Sparkles,
    path: 'https://[votre-wavepix].lovable.app',
    external: true
  }
];

export default function AdminCXLabHome() {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) !== 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    navigate('/admin');
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>CX Lab - Cosmos Wave</title>
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h1 className="text-3xl font-bold mb-2">CX Lab</h1>
              <p className="text-muted-foreground">
                Outils et ressources pour optimiser votre présence Amazon
              </p>
            </div>
            <Button variant="outline" onClick={handleLogout}>
              <LogOut className="w-4 h-4 mr-2" />
              Déconnexion
            </Button>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {sections.map((section) => (
              <Card key={section.id} className="hover:shadow-lg transition-shadow flex flex-col">
                <CardHeader>
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                    <section.icon className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle>{section.title}</CardTitle>
                  <CardDescription>{section.description}</CardDescription>
                </CardHeader>
                <CardContent className="mt-auto">
                  {section.external ? (
                    <Button 
                      className="w-full group" 
                      onClick={() => window.open(section.path, '_blank')}
                    >
                      Accéder
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  ) : (
                    <Button asChild className="w-full group">
                      <Link to={section.path}>
                        Accéder
                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                      </Link>
                    </Button>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
